import type { PredictionContract, PredictionTeamScore } from '@/services/prediction/types'

/**
 * Port of cdc-web `src/utils/liveScore.ts`（TwoWayCard 只需要 `getScoreForContract`；
 * 盘局/发球相关的 `isSetWon` / `getServingId` / `getCurrentPoints` 不抄）。
 */

/** The competitor ids used to match a contract to a live-coverage score row. */
function contractMatchIds(contract: PredictionContract | undefined): string[] {
  const ids: string[] = []
  if (contract?.individual_profile?.id) ids.push(contract.individual_profile.id)
  if (contract?.team_id) ids.push(contract.team_id)
  return ids
}

/** Resolve the live score row for a contract by individual id, then team id. */
export function getScoreForContract(
  contract: PredictionContract | undefined,
  scores: PredictionTeamScore[] | undefined,
): PredictionTeamScore | undefined {
  if (!contract || !scores?.length) return undefined
  const ids = contractMatchIds(contract)
  for (const id of ids) {
    const match = scores.find(
      s => (!!s.individual_id && s.individual_id === id) || (!!s.team_id && s.team_id === id),
    )
    if (match) return match
  }
  return undefined
}
